import React from 'react';
import './SkillsSection.css';
import paintIcon from '../asset/icons/paint-icon.svg';
import woodIcon from '../asset/icons/wood-icon.svg';
import architecturalIcon from '../asset/icons/architectural-icon.svg';
import skillImg1 from '../asset/images/restauro-pulitura-dipinto-antico.webp';
import skillImg2 from '../asset/images/restauro-ricostruzione-cornice-legno.webp';
import skillImg3 from '../asset/images/restauro-lapideo-palazzocastiglioni-milano.webp';

const SkillsSection = () => {
  return (
    <section className="skills-section" id="competenze">
      <div className="container">
        <div className="skills-header">
          <div className="section-title-decoration">
            <div className="decoration-line"></div>
            <div className="decoration-circle"></div>
            <div className="decoration-line"></div>
          </div>
          <h2 className="section-title">Competenze</h2>
          <p className="section-description">
            Le mie competenze di conservazione e restauro<br />
            permettono di recuperare, preservare e valorizzare<br />
            il patrimonio artistico e culturale,<br />
            su una molteplicità di supporti e materiali.
          </p>
        </div>
        
        <div className="skills-slider">
          <div className="skill-card">
            <div className="skill-content">
              <div className="skill-icon-container">
                <img src={paintIcon} alt="" className="skill-icon" />
              </div>
              <div className="skill-text">
                <h3 className="skill-title">Restauro pittorico</h3>
                <p className="skill-description">
                  Restauro di dipinti, affreschi e decorazioni murali con tecniche specializzate di pulitura, consolidamento e integrazione pittorica
                </p>
              </div>
            </div>
            <div className="skill-image" style={{ backgroundImage: `url(${skillImg1})` }} aria-hidden="true"></div>
          </div>
          
          <div className="skill-card">
            <div className="skill-content">
              <div className="skill-icon-container">
                <img src={woodIcon} alt="" className="skill-icon" />
              </div>
              <div className="skill-text">
                <h3 className="skill-title">Restauro ligneo</h3>
                <p className="skill-description">
                  Recupero di opere lignee, mobili storici e manufatti decorati con tecniche di restauro conservative e reversibili
                </p>
              </div>
            </div>
            <div className="skill-image" style={{ backgroundImage: `url(${skillImg2})` }} aria-hidden="true"></div>
          </div>
          
          <div className="skill-card">
            <div className="skill-content">
              <div className="skill-icon-container">
                <img src={architecturalIcon} alt="" className="skill-icon" />
              </div>
              <div className="skill-text">
                <h3 className="skill-title">Restauro architettonico e lapideo</h3>
                <p className="skill-description">
                  Interventi su facciate storiche, elementi decorativi e superfici architettoniche con tecniche di consolidamento, pulitura, valorizzazione
                </p>
              </div>
            </div>
            <div className="skill-image" style={{ backgroundImage: `url(${skillImg3})` }} aria-hidden="true"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection; 